/**
 * Simulate UserWay accessibility icon click
 *
 * @param {boolean} [enableDebug=false] - Enable debugging output
 */
export default (enableDebug = false) => {
	const debug = enableDebug;

	const triggerBtn = document.getElementById('js-userway-click');
	if (!triggerBtn) return;

	triggerBtn.addEventListener('click', () => {
		let attempts = 0;
		const maxAttempts = 3;

		const tryClick = () => {
			const icon = document.getElementById('userwayAccessibilityIcon');

			if (icon) {
				if (debug) console.log('UserWay icon found, simulating click.');
				icon.click();
			} else if (attempts < maxAttempts) {
				attempts++;
				if (debug) console.log(`UserWay icon not found. Retrying... (${attempts}/${maxAttempts})`);
				setTimeout(tryClick, 300);
			} else {
				if (debug) console.warn('UserWay icon not found after 3 attempts.');
			}
		};

		tryClick();
	});
};
